/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_PublicInputs */

const cs_settings_profile_public = /** @type {(inputs: Settings_Profile_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veřejný profil`)
};

const en_settings_profile_public = /** @type {(inputs: Settings_Profile_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public profile`)
};

/**
* | output |
* | --- |
* | "Public profile" |
*
* @param {Settings_Profile_PublicInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_public = /** @type {((inputs?: Settings_Profile_PublicInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_PublicInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_public(inputs)
	return cs_settings_profile_public(inputs)
});